(function () {
  // Solo en dispositivos con hover real (mouse), nunca en touch — en
  // mobile/tablet el drawer se abre exclusivamente con el toque directo
  // sobre el ícono, que Dawn (cart-drawer.js) ya maneja nativamente vía
  // el listener de click que agrega a #cart-icon-bubble.
  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!supportsHover) return;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    var trigger = document.getElementById('cart-icon-bubble');
    var drawer = document.querySelector('cart-drawer');
    if (!trigger || !drawer) return;

    var closeTimer = null;
    var CLOSE_DELAY = 200; // ms de margen para mover el mouse del ícono al panel sin que se cierre de golpe

    function openDrawer() {
      clearTimeout(closeTimer);
      // El propio custom element ya se protege contra abrir dos veces
      // (revisa this.classList.contains('active') internamente).
      drawer.open(trigger);
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        drawer.close();
      }, CLOSE_DELAY);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    trigger.addEventListener('mouseenter', openDrawer);
    trigger.addEventListener('mouseleave', scheduleClose);

    // El panel real vive dentro de #CartDrawer — si el mouse entra ahí,
    // cancela el cierre programado; si sale de ahí, se cierra con el
    // mismo margen.
    var panel = drawer.querySelector('#CartDrawer');
    if (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    }
  }
})();
